module.exports = new __parcel__URL__("about-us.76a2c60c.jpg").toString();